import lazyLoadView from '@router/lazy-loader'
import ContainerView from './views/main.vue'
import configs from './config'

const routePrefix = configs.routePrefix

const moduleName = configs.name

const routeNamePrefix = configs.routeNamePrefix

export default [
  {
    path: `${routePrefix}`,
    component: ContainerView,
    meta: { moduleName, breadcrumbKey: 'user', nonLinked: true },
    children: [
      {
        path: '',
        name: routeNamePrefix,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "users" */ './views/list.vue')
          ),
        meta: {
          breadcrumbKey: 'custom_scope_configuration',
        },
      },
      {
        path: 'create',
        name: `${routeNamePrefix}.create`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "users" */ './views/create.vue')
          ),
        meta: {
          breadcrumbKey: 'custom_scope_configuration',
        },
      },
      {
        path: 'edit/:id',
        name: `${routeNamePrefix}.edit`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "users" */ './views/edit.vue')
          ),
        meta: {
          breadcrumbKey: 'custom_scope_configuration',
        },
      },
    ],
  },
]
